import store from "@/store";
import router from "@/router/router";
import { ConversationMutation } from "@/framework/store/conversation/types";
import { i18n } from "@/framework/plugins/i18n";
import { AccessLogRepository, LogAction } from "@/framework/logger/accessLog/accessLogRepository";
import { ErrorService } from "@/framework/errors/ErrorService";
import { InquiryService } from "@/framework/api/Staff/ChatService/InquiryService";

export const completeInquiry = async (
  conversationId: string,
  responderId: number,
  chatState: string
): Promise<void> => {
  console.log("対応が完了しました");
  const completeGuestInquiryResult = await new InquiryService().completeGuestInquiry(
    conversationId,
    responderId,
    undefined,
    undefined,
    chatState
  );
  if (completeGuestInquiryResult.isOk()) {
    // 成功してたら会話一覧に飛ばす
    router.push({ path: `/${i18n.locale}/conversations` });
    store.commit(ConversationMutation.SET_IMPORTANCE, "");
  } else {
    await new ErrorService().handleError(completeGuestInquiryResult.error);
    console.log("Error complete inquiry : ", completeGuestInquiryResult.error);
    // エラーの場合、どうするか
    // 一旦会話一覧に戻す
    router.push({ path: `/${i18n.locale}/conversations` });
  }
  void new AccessLogRepository().sendFePWAStaffLog(LogAction.CompleteQuery, {
    conversation_id: conversationId,
  });
};
